import React from 'react'
import ModalPortal from '@Components/Popups/ModalPortal'
import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'

interface SubmissionSuccessModalProps {
    isOpen: boolean
    onConfirm: () => void
}

const SubmissionSuccessModal = ({ isOpen, onConfirm }: SubmissionSuccessModalProps) => (
    <ModalPortal isOpen={isOpen}>
        <Popup onClose={() => {}} showClose={false}>
            <ConfirmationPopup title="Your Update Has Been Submitted" onConfirm={onConfirm} confirmButtonText="Done">
                Your request has been submitted to your publisher/administrator. Any updates or changes will be
                determined by their review process.
            </ConfirmationPopup>
        </Popup>
    </ModalPortal>
)

export default SubmissionSuccessModal
